import { selectedSidebarFiltersAtom } from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { DEFAULT_ALL_RADIO_OPTION_ID } from '@redux/search';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

export const useSelectRadioSidebarFilter = () => {
	const [selectedSidebarFilters, setSelectedSidebarFilters] = useAtom(
		selectedSidebarFiltersAtom,
	);

	return useCallback(
		(value: string, previous?: string) => {
			if (value === DEFAULT_ALL_RADIO_OPTION_ID) {
				setSelectedSidebarFilters(
					selectedSidebarFilters.filter((item) => item !== previous),
				);
			} else {
				setSelectedSidebarFilters([
					...selectedSidebarFilters.filter(
						(item) => item !== value && item !== previous,
					),
					value,
				]);
			}
		},
		[selectedSidebarFilters, setSelectedSidebarFilters],
	);
};
